import styled from 'styled-components';

export const Container = styled.main`
  position: relative;
  overflow: hidden;
`;
